import { CheckBadgeIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import StripeDialog from "./stripe-dialog";
import { TWclassNames } from "../../utils/Div";

export const StripePaymentStatus = ({ order }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      {order && order?.stripe_session?.id ? (
        <div
          onClick={() => setDialogOpen(true)}
          className={TWclassNames(
            order?.stripe_session?.payment_status === "paid"
              ? "text-green-500"
              : "text-red-500",
            "flex rounded-md py-2 cursor-pointer"
          )}
        >
          {order?.stripe_session?.payment_status === "paid" ? (
            <CheckBadgeIcon className="h-5 w-5" />
          ) : (
            <XCircleIcon className="h-5 w-5" />
          )}
          <span className="px-1">
            {order?.stripe_session?.payment_status === "paid"
              ? "Betalt med Stripe"
              : "Stripe: Ubetalt"}
          </span>
        </div>
      ) : null}

      <StripeDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        selected={order}
      />
    </>
  );
};
